import {
  Chat,
  ContentPaste,
  QuestionAnswer,
  Groups,
  Dashboard,
  EmojiEvents,
  BrunchDining,
  OndemandVideo,
  Description,
  AutoStories,
  School,
  DataThresholding,
} from '@mui/icons-material';
import ShareIcon from '@mui/icons-material/Share';
import ReorderIcon from '@mui/icons-material/Reorder';
import React from 'react';

const patient_menuItems = [
  {
    icon: <Dashboard />,
    tooltip: 'Dashboard',
    text: 'Dashboard',
    slug: 'dashboard',
    category: 'dashboard',
    path: '/dashboard',
  },
  {
    icon: <ContentPaste />,
    tooltip: 'Patient Charts',
    text: 'Patient Charts',
    slug: 'patients',
    category: 'patients',
    path: '/patients',
  },
  // {
  //     icon: <DataThresholding />,
  //     tooltip: 'Metric Reporting',
  //     text: 'Metrics',
  //     slug: 'metrics',
  //     category: 'patients',
  //     path: '/metrics',
  // },
  {
    icon: <ReorderIcon />,
    tooltip: 'Resources',
    text: 'Resources',
    slug: 'resources',
    category: 'resources',
    path: '/resources',
    url: 'https://www.dietid.com/clientresources',
  },
  {
    icon: <School />,
    tooltip: 'Browse the Education Center',
    text: 'Education',
    slug: 'learn',
    category: 'learn',
    path: '/learn',
    children: [
      {
        icon: <AutoStories />,
        text: 'Guidebooks',
        path: '/browse/people',
      },
      {
        icon: <Description />,
        text: 'Articles',
        path: '/browse/places',
      },
      {
        icon: <OndemandVideo />,
        text: 'Videos',
        path: '/browse/communications',
      },
      {
        icon: <BrunchDining />,
        text: 'Recipes',
        path: '/browse/questions_&_answers',
      },
    ],
  },
  {
    icon: <Groups />,
    tooltip: 'Community',
    text: 'Community',
    slug: 'community',
    category: 'community',
    path: '/community',
    children: [
      {
        icon: <QuestionAnswer />,
        text: 'Community Questions',
        path: '/community/questions',
      },
      {
        icon: <EmojiEvents />,
        text: 'Wins',
        path: '/community/wins',
      },
    ],
  },
  {
    icon: <Chat />,
    tooltip: 'Inbox',
    text: 'Inbox',
    slug: 'inbox',
    category: 'inbox',
    path: '/inbox',
  },
  {
    icon: <ShareIcon />,
    tooltip: 'Share Link',
    text: 'Share Link',
    slug: 'share-link',
    category: 'share-link',
    onClick: () => setShowShareLinkDialog(true),
  },
];

export default patient_menuItems;
